module.exports = __webpack_public_path__ + "img/lite.77694c30.jpg";